import { TableCellProps, TableColumnHeaderProps, Td } from '@chakra-ui/react';

export const MeteraTh = ({ children, ...rest }: TableColumnHeaderProps) => (
  <Td
    overflow="hidden"
    fontSize={'1rem'}
    color="white"
    cursor="pointer"
    borderRadius="2rem"
    {...rest}
  >
    {children}
  </Td>
);

export const MeteraTd = ({ children, ...rest }: TableCellProps) => (
  <Td
    overflow="hidden"
    whiteSpace={'nowrap'}
    textOverflow="ellipsis"
    p={0}
    h="40px"
    textAlign="center"
    {...rest}
  >
    {children}
  </Td>
);
